module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/elo-719b58c99e5fe9e0c642a2e3524b3636.svg";